import { createContext, useContext, useEffect, useState, useMemo } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import lodash from "lodash";
import { useDebounce } from "hooks/useDebounce";

//Actions
import {
  getDetailImages,
  getMarketingAgent,
  exportListing,
  archiveListing,
  getDetailOfficeListing,
  activedListing,
  deleteListing,
} from "actions";

import { GlobalContext } from "contexts";

// api
import { useGetListListingOffice } from "api/list-listing/query";
import {
  useActiveBulkProperties,
  useDeleteBulkProperties,
} from "api/list-listing/mutation";

//Functions
const DetailListingCtx = createContext(null);

export const DetailListingProvider = ({ children }) => {
  const navigate = useNavigate();
  const { profile } = useContext(GlobalContext);
  const [isOpenModalImages, setIsOpenModalImages] = useState(false);

  const {
    mutate: activeBulkProperties,
    isLoading: isPendingActiveBulkProperties,
  } = useActiveBulkProperties();
  const {
    mutate: deleteBulkProperties,
    isLoading: isPendingDeleteBulkProperties,
  } = useDeleteBulkProperties();

  //banner inactive state
  const [loading, setLoading] = useState(false);

  const [listDetail, setListDetail] = useState(null);
  const [detailImages, setDetailImages] = useState({
    data: [],
    loading: false,
  });

  //Search handler
  const [search, setSearch] = useState("");
  const [openModalFilter, setOpenModalFilter] = useState(null);

  const [agents, setAgents] = useState({
    data: [],
    fetching: true,
    error: "",
  });

  const [params, setParams] = useState({
    page: 1,
    keywords: "",
    agent: null,
    filter: "active",
    _for: "office_dashboard",
    _limit: 10,
    is_pjp: null,
  });

  const [selectedListings, setSelectedListings] = useState([]);

  const mappedParams = useMemo(() => {
    let newParams = {
      page: params.page,
      keywords: params.keywords,
      _limit: params._limit,
      _for: "office_dashboard",
      is_pjp: params.is_pjp,
    };

    !!params?.agent?.id && (newParams.user_id = params.agent.id);

    if (params.filter === "active") {
      newParams.listing_status = 1;
    } else if (params.filter === "terjual") {
      newParams.property_type_id = 1;
      newParams.is_archived = true;
    } else if (params.filter === "tersewa") {
      newParams.is_archived = true;
      newParams.property_type_id = 2;
    } else if (params.filter === "inactive") {
      newParams.listing_status = 0;
    }

    return newParams;
  }, [params]);

  const {
    data: listListingOffice,
    isFetching: isFetchingListingOffice,
    refetch: refetchListListing,
  } = useGetListListingOffice({
    params: mappedParams,
  });

  const totalPage = useMemo(() => {
    const totalItem = listListingOffice?.headers?.["x-total"];

    return lodash.ceil(totalItem / 10) || 0;
  }, [listListingOffice]);

  const isSearchingOrFiltering = useMemo(() => {
    return !!search || !!params.agent;
  }, [search, params.agent]);

  const { debounceFn } = useDebounce({
    onChange: (newParams) => setParams(newParams),
  });

  const searchHandler = (e) => {
    const __value = e.target.value || "";
    setSearch(__value);
    debounceFn({ ...params, keywords: __value, page: 1 });
  };

  const getValue = (str = "") => _.get(listDetail, str);

  const _getActivedListing = async (slug) => {
    try {
      setLoading(true);
      await activedListing(slug);

      refetchListListing();
      setListDetail(null);
      toast.success("Listing berhasil di aktifkan.");
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ?? "Gagal mengaktifkan listing."
      );
    }
  };

  const _getMarkerListing = async (slug) => {
    try {
      setLoading(true);
      await archiveListing(slug);
      refetchListListing();
      setListDetail(null);

      toast.success("Listing berhasil di arsipkan.");
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ?? "Gagal mengarsipkan listing."
      );
    }
  };

  const _getDeleteListing = async (slug) => {
    try {
      setLoading(true);
      await deleteListing(slug);

      refetchListListing();

      setListDetail(null);
      toast.success("Listing berhasil di hapuskan.");
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message ?? "Gagal menghapus listing.");
    }
  };
  const _getDetailImages = async (link) => {
    try {
      setDetailImages((val) => ({ ...val, loading: true }));

      const images = await getDetailImages(link);

      setDetailImages((val) => ({ ...val, data: images.data || [] }));
    } catch (error) {
      setDetailImages((val) => ({ ...val, data: [] }));
      console.log(error);
    } finally {
      setTimeout(() => {
        setDetailImages((val) => ({ ...val, loading: false }));
      }, 500);
    }
  };

  const goToUbahListing = async () => {
    const url = "/upload-listing/" + listDetail?.slug;
    navigate(url);
  };

  const getAgents = async () => {
    try {
      setAgents((val) => ({ ...val, fetching: true, error: "" }));

      const list = await getMarketingAgent("?page=1&_limit=99999");

      const newData = list?.data ?? [];

      setAgents((val) => ({ ...val, data: newData }));
    } catch (error) {
      setAgents((val) => ({ ...val, error }));
    } finally {
      setAgents((val) => ({ ...val, fetching: false }));
    }
  };

  const exportToExcel = async (periodFrom, periodTo) => {
    try {
      let query = `?company_ids[]=${profile?.company?.id}&date[from]=${periodFrom}&date[to]=${periodTo}`;
      if (!!params?.agent?.id) {
        query += `&user_id=${params?.agent?.id}`;
      }
      const response = await exportListing(query);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const fileName = `Listing C21 ${profile?.company?.name} ${periodFrom} - ${periodTo}.xlsx`;
      link.setAttribute("download", fileName); // or any other extension
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const resetFilter = () => {
    setSearch("");
    setParams({
      ...params,
      page: 1,
      keywords: "",
      agent: null,
    });
  };

  const handleGetDetailListing = async (slug) => {
    try {
      const res = await getDetailOfficeListing(slug);

      setListDetail(res?.data ?? null);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? "Gagal mendapatkan detail listing."
      );
    }
  };

  const handleActiveBulkProperties = async () => {
    const payload = { property_ids: selectedListings };
    activeBulkProperties(payload, {
      onSuccess: () => {
        refetchListListing();
        setSelectedListings([]);
      },
      onError: (e) => {
        toast.error(
          e?.response?.data?.message ?? "Gagal mengaktifkan listing."
        );
      },
    });
  };

  const handleDeleteBulkProperties = async () => {
    const payload = { property_ids: selectedListings };
    deleteBulkProperties(payload, {
      onSuccess: () => {
        refetchListListing();
        setSelectedListings([]);
      },
      onError: (e) => {
        toast.error(e?.response?.data?.message ?? "Gagal menghapus listing.");
      },
    });
  };

  useEffect(() => {
    const _data = listListingOffice?.data?.data ?? [];
    if (!listDetail && !!_data.length) {
      setListDetail(_data[0]);
    }
  }, [listListingOffice, listDetail]);

  useEffect(() => {
    const links = _.get(listDetail, "links.property_images");
    links && _getDetailImages(links);
  }, [listDetail]);

  useEffect(() => {
    getAgents();
  }, []);

  return (
    <DetailListingCtx.Provider
      value={{
        isOpenModalImages,
        listDetail,
        detailImages,
        search,
        agents,
        openModalFilter,
        agent: params.agent,
        isSearchingOrFiltering,
        company: profile?.company?.name,
        filter: params.filter,
        loading,
        params,
        setParams,
        resetFilter,
        setOpenModalFilter,
        getValue,
        setListDetail,
        setIsOpenModalImages,
        getAllMyListings: refetchListListing,
        goToUbahListing,
        searchHandler,
        exportToExcel,
        _getActivedListing,
        _getMarkerListing,
        _getDeleteListing,
        handleGetDetailListing,
        totalPage,
        isLoading:
          isFetchingListingOffice ||
          isPendingActiveBulkProperties ||
          isPendingDeleteBulkProperties,
        listData: listListingOffice?.data?.data ?? [],
        selectedListings,
        setSelectedListings,
        handleActiveBulkProperties,
        handleDeleteBulkProperties,
      }}
    >
      {children}
    </DetailListingCtx.Provider>
  );
};

//Custom hooks for the values
export const useDetailListingCtx = () => {
  const ctx = useContext(DetailListingCtx);

  if (!ctx) {
    throw new Error("useERState must be used within the DetailListingProvider");
  }

  return ctx;
};
